/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as PrivateLayoutRouteImport } from './routes/_private/layout'
import { Route as GuestLayoutRouteImport } from './routes/_guest/layout'
import { Route as PrivatewithFooterLayoutRouteImport } from './routes/_private/(with-footer)/layout'
import { Route as PrivatefaqsLayoutRouteImport } from './routes/_private/(faqs)/layout'
import { Route as GuestPostPurchaseLayoutRouteImport } from './routes/_guest/post-purchase/layout'
import { Route as PrivateSurveyPageRouteImport } from './routes/_private/survey.page'
import { Route as PrivateMessagesPageRouteImport } from './routes/_private/messages.page'
import { Route as PrivatewithFooterPageRouteImport } from './routes/_private/(with-footer)/page'
import { Route as GuestResetPasswordPageRouteImport } from './routes/_guest/reset-password.page'
import { Route as GuestProfilingPageRouteImport } from './routes/_guest/profiling/page'
import { Route as GuestPostPurchasePageRouteImport } from './routes/_guest/post-purchase/page'
import { Route as GuestPersonifyGetStartedPageRouteImport } from './routes/_guest/personify-get-started.page'
import { Route as GuestPasswordUpdatedPageRouteImport } from './routes/_guest/password-updated.page'
import { Route as GuestPasswordExpiredPageRouteImport } from './routes/_guest/password-expired.page'
import { Route as GuestLoginPageRouteImport } from './routes/_guest/login.page'
import { Route as GuestForgotPasswordPageRouteImport } from './routes/_guest/forgot-password.page'
import { Route as GuestProfilingCustomQuestionsLayoutRouteImport } from './routes/_guest/profiling/_custom-questions/layout'
import { Route as PrivatewithFooterProgressPageRouteImport } from './routes/_private/(with-footer)/progress/page'
import { Route as PrivatewithFooterProductResearchAndTestingPageRouteImport } from './routes/_private/(with-footer)/product-research-and-testing/page'
import { Route as PrivatewithFooterClinicalTeamPageRouteImport } from './routes/_private/(with-footer)/clinical-team/page'
import { Route as PrivatewithFooterCareplanPageRouteImport } from './routes/_private/(with-footer)/careplan/page'
import { Route as PrivatewithFooterCannabis101PageRouteImport } from './routes/_private/(with-footer)/cannabis-101/page'
import { Route as PrivatewithFooterSplatPageRouteImport } from './routes/_private/(with-footer)/$.page'
import { Route as PrivatefaqsMorePageRouteImport } from './routes/_private/(faqs)/more/page'
import { Route as PrivatefaqsFaqsPageRouteImport } from './routes/_private/(faqs)/faqs/page'
import { Route as GuestProfilingPasswordPageRouteImport } from './routes/_guest/profiling/password.page'
import { Route as GuestPostPurchaseSurveyPageRouteImport } from './routes/_guest/post-purchase/survey.page'
import { Route as GuestPostPurchaseSubscribePageRouteImport } from './routes/_guest/post-purchase/subscribe.page'
import { Route as GuestPostPurchaseRecommendationsPageRouteImport } from './routes/_guest/post-purchase/recommendations/page'
import { Route as GuestProfilingCustomQuestionsOtpRouteImport } from './routes/_guest/profiling/_custom-questions/otp'
import { Route as GuestProfilingCustomQuestionsHpFeedbackRouteImport } from './routes/_guest/profiling/_custom-questions/hp-feedback'
import { Route as GuestProfilingCustomQuestionsEmailCheckRouteImport } from './routes/_guest/profiling/_custom-questions/email-check'
import { Route as PrivatefaqsFaqsIdPageRouteImport } from './routes/_private/(faqs)/faqs/$id.page'
import { Route as GuestAuthOidcReturnPageRouteImport } from './routes/_guest/auth/oidc/return/page'

const GuestProfilingRouteImport = createFileRoute('/_guest/profiling')()

const PrivateLayoutRoute = PrivateLayoutRouteImport.update({
  id: '/_private',
  getParentRoute: () => rootRouteImport,
} as any)
const GuestLayoutRoute = GuestLayoutRouteImport.update({
  id: '/_guest',
  getParentRoute: () => rootRouteImport,
} as any)
const GuestProfilingRoute = GuestProfilingRouteImport.update({
  id: '/profiling',
  path: '/profiling',
  getParentRoute: () => GuestLayoutRoute,
} as any)
const PrivatewithFooterLayoutRoute = PrivatewithFooterLayoutRouteImport.update({
  id: '/(with-footer)',
  getParentRoute: () => PrivateLayoutRoute,
} as any)
const PrivatefaqsLayoutRoute = PrivatefaqsLayoutRouteImport.update({
  id: '/(faqs)',
  getParentRoute: () => PrivateLayoutRoute,
} as any)
const GuestPostPurchaseLayoutRoute = GuestPostPurchaseLayoutRouteImport.update({
  id: '/post-purchase',
  path: '/post-purchase',
  getParentRoute: () => GuestLayoutRoute,
} as any)
const PrivateSurveyPageRoute = PrivateSurveyPageRouteImport.update({
  id: '/survey/',
  path: '/survey/',
  getParentRoute: () => PrivateLayoutRoute,
} as any)
const PrivateMessagesPageRoute = PrivateMessagesPageRouteImport.update({
  id: '/messages/',
  path: '/messages/',
  getParentRoute: () => PrivateLayoutRoute,
} as any)
const PrivatewithFooterPageRoute = PrivatewithFooterPageRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PrivatewithFooterLayoutRoute,
} as any)
const GuestResetPasswordPageRoute = GuestResetPasswordPageRouteImport.update({
  id: '/reset-password/',
  path: '/reset-password/',
  getParentRoute: () => GuestLayoutRoute,
} as any)
const GuestProfilingPageRoute = GuestProfilingPageRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => GuestProfilingRoute,
} as any)
const GuestPostPurchasePageRoute = GuestPostPurchasePageRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => GuestPostPurchaseLayoutRoute,
} as any)
const GuestPersonifyGetStartedPageRoute =
  GuestPersonifyGetStartedPageRouteImport.update({
    id: '/personify-get-started/',
    path: '/personify-get-started/',
    getParentRoute: () => GuestLayoutRoute,
  } as any)
const GuestPasswordUpdatedPageRoute =
  GuestPasswordUpdatedPageRouteImport.update({
    id: '/password-updated/',
    path: '/password-updated/',
    getParentRoute: () => GuestLayoutRoute,
  } as any)
const GuestPasswordExpiredPageRoute =
  GuestPasswordExpiredPageRouteImport.update({
    id: '/password-expired/',
    path: '/password-expired/',
    getParentRoute: () => GuestLayoutRoute,
  } as any)
const GuestLoginPageRoute = GuestLoginPageRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => GuestLayoutRoute,
} as any)
const GuestForgotPasswordPageRoute = GuestForgotPasswordPageRouteImport.update({
  id: '/forgot-password/',
  path: '/forgot-password/',
  getParentRoute: () => GuestLayoutRoute,
} as any)
const GuestProfilingCustomQuestionsLayoutRoute =
  GuestProfilingCustomQuestionsLayoutRouteImport.update({
    id: '/_custom-questions',
    getParentRoute: () => GuestProfilingRoute,
  } as any)
const PrivatewithFooterProgressPageRoute =
  PrivatewithFooterProgressPageRouteImport.update({
    id: '/progress/',
    path: '/progress/',
    getParentRoute: () => PrivatewithFooterLayoutRoute,
  } as any)
const PrivatewithFooterProductResearchAndTestingPageRoute =
  PrivatewithFooterProductResearchAndTestingPageRouteImport.update({
    id: '/product-research-and-testing/',
    path: '/product-research-and-testing/',
    getParentRoute: () => PrivatewithFooterLayoutRoute,
  } as any)
const PrivatewithFooterClinicalTeamPageRoute =
  PrivatewithFooterClinicalTeamPageRouteImport.update({
    id: '/clinical-team/',
    path: '/clinical-team/',
    getParentRoute: () => PrivatewithFooterLayoutRoute,
  } as any)
const PrivatewithFooterCareplanPageRoute =
  PrivatewithFooterCareplanPageRouteImport.update({
    id: '/careplan/',
    path: '/careplan/',
    getParentRoute: () => PrivatewithFooterLayoutRoute,
  } as any)
const PrivatewithFooterCannabis101PageRoute =
  PrivatewithFooterCannabis101PageRouteImport.update({
    id: '/cannabis-101/',
    path: '/cannabis-101/',
    getParentRoute: () => PrivatewithFooterLayoutRoute,
  } as any)
const PrivatewithFooterSplatPageRoute =
  PrivatewithFooterSplatPageRouteImport.update({
    id: '/$/',
    path: '/$/',
    getParentRoute: () => PrivatewithFooterLayoutRoute,
  } as any)
const PrivatefaqsMorePageRoute = PrivatefaqsMorePageRouteImport.update({
  id: '/more/',
  path: '/more/',
  getParentRoute: () => PrivatefaqsLayoutRoute,
} as any)
const PrivatefaqsFaqsPageRoute = PrivatefaqsFaqsPageRouteImport.update({
  id: '/faqs/',
  path: '/faqs/',
  getParentRoute: () => PrivatefaqsLayoutRoute,
} as any)
const GuestProfilingPasswordPageRoute =
  GuestProfilingPasswordPageRouteImport.update({
    id: '/password/',
    path: '/password/',
    getParentRoute: () => GuestProfilingRoute,
  } as any)
const GuestPostPurchaseSurveyPageRoute =
  GuestPostPurchaseSurveyPageRouteImport.update({
    id: '/survey/',
    path: '/survey/',
    getParentRoute: () => GuestPostPurchaseLayoutRoute,
  } as any)
const GuestPostPurchaseSubscribePageRoute =
  GuestPostPurchaseSubscribePageRouteImport.update({
    id: '/subscribe/',
    path: '/subscribe/',
    getParentRoute: () => GuestPostPurchaseLayoutRoute,
  } as any)
const GuestPostPurchaseRecommendationsPageRoute =
  GuestPostPurchaseRecommendationsPageRouteImport.update({
    id: '/recommendations/',
    path: '/recommendations/',
    getParentRoute: () => GuestPostPurchaseLayoutRoute,
  } as any)
const GuestProfilingCustomQuestionsOtpRoute =
  GuestProfilingCustomQuestionsOtpRouteImport.update({
    id: '/otp',
    path: '/otp',
    getParentRoute: () => GuestProfilingCustomQuestionsLayoutRoute,
  } as any)
const GuestProfilingCustomQuestionsHpFeedbackRoute =
  GuestProfilingCustomQuestionsHpFeedbackRouteImport.update({
    id: '/hp-feedback',
    path: '/hp-feedback',
    getParentRoute: () => GuestProfilingCustomQuestionsLayoutRoute,
  } as any)
const GuestProfilingCustomQuestionsEmailCheckRoute =
  GuestProfilingCustomQuestionsEmailCheckRouteImport.update({
    id: '/email-check',
    path: '/email-check',
    getParentRoute: () => GuestProfilingCustomQuestionsLayoutRoute,
  } as any)
const PrivatefaqsFaqsIdPageRoute = PrivatefaqsFaqsIdPageRouteImport.update({
  id: '/faqs/$id/',
  path: '/faqs/$id/',
  getParentRoute: () => PrivatefaqsLayoutRoute,
} as any)
const GuestAuthOidcReturnPageRoute = GuestAuthOidcReturnPageRouteImport.update({
  id: '/auth/oidc/return/',
  path: '/auth/oidc/return/',
  getParentRoute: () => GuestLayoutRoute,
} as any)

export interface FileRoutesByFullPath {
  '/post-purchase': typeof GuestPostPurchaseLayoutRouteWithChildren
  '/profiling': typeof GuestProfilingCustomQuestionsLayoutRouteWithChildren
  '/forgot-password': typeof GuestForgotPasswordPageRoute
  '/login': typeof GuestLoginPageRoute
  '/password-expired': typeof GuestPasswordExpiredPageRoute
  '/password-updated': typeof GuestPasswordUpdatedPageRoute
  '/personify-get-started': typeof GuestPersonifyGetStartedPageRoute
  '/post-purchase/': typeof GuestPostPurchasePageRoute
  '/profiling/': typeof GuestProfilingPageRoute
  '/reset-password': typeof GuestResetPasswordPageRoute
  '/': typeof PrivatewithFooterPageRoute
  '/messages': typeof PrivateMessagesPageRoute
  '/survey': typeof PrivateSurveyPageRoute
  '/profiling/email-check': typeof GuestProfilingCustomQuestionsEmailCheckRoute
  '/profiling/hp-feedback': typeof GuestProfilingCustomQuestionsHpFeedbackRoute
  '/profiling/otp': typeof GuestProfilingCustomQuestionsOtpRoute
  '/post-purchase/recommendations': typeof GuestPostPurchaseRecommendationsPageRoute
  '/post-purchase/subscribe': typeof GuestPostPurchaseSubscribePageRoute
  '/post-purchase/survey': typeof GuestPostPurchaseSurveyPageRoute
  '/profiling/password': typeof GuestProfilingPasswordPageRoute
  '/faqs': typeof PrivatefaqsFaqsPageRoute
  '/more': typeof PrivatefaqsMorePageRoute
  '/$': typeof PrivatewithFooterSplatPageRoute
  '/cannabis-101': typeof PrivatewithFooterCannabis101PageRoute
  '/careplan': typeof PrivatewithFooterCareplanPageRoute
  '/clinical-team': typeof PrivatewithFooterClinicalTeamPageRoute
  '/product-research-and-testing': typeof PrivatewithFooterProductResearchAndTestingPageRoute
  '/progress': typeof PrivatewithFooterProgressPageRoute
  '/auth/oidc/return': typeof GuestAuthOidcReturnPageRoute
  '/faqs/$id': typeof PrivatefaqsFaqsIdPageRoute
}
export interface FileRoutesByTo {
  '/profiling': typeof GuestProfilingPageRoute
  '/forgot-password': typeof GuestForgotPasswordPageRoute
  '/login': typeof GuestLoginPageRoute
  '/password-expired': typeof GuestPasswordExpiredPageRoute
  '/password-updated': typeof GuestPasswordUpdatedPageRoute
  '/personify-get-started': typeof GuestPersonifyGetStartedPageRoute
  '/post-purchase': typeof GuestPostPurchasePageRoute
  '/reset-password': typeof GuestResetPasswordPageRoute
  '/': typeof PrivatewithFooterPageRoute
  '/messages': typeof PrivateMessagesPageRoute
  '/survey': typeof PrivateSurveyPageRoute
  '/profiling/email-check': typeof GuestProfilingCustomQuestionsEmailCheckRoute
  '/profiling/hp-feedback': typeof GuestProfilingCustomQuestionsHpFeedbackRoute
  '/profiling/otp': typeof GuestProfilingCustomQuestionsOtpRoute
  '/post-purchase/recommendations': typeof GuestPostPurchaseRecommendationsPageRoute
  '/post-purchase/subscribe': typeof GuestPostPurchaseSubscribePageRoute
  '/post-purchase/survey': typeof GuestPostPurchaseSurveyPageRoute
  '/profiling/password': typeof GuestProfilingPasswordPageRoute
  '/faqs': typeof PrivatefaqsFaqsPageRoute
  '/more': typeof PrivatefaqsMorePageRoute
  '/$': typeof PrivatewithFooterSplatPageRoute
  '/cannabis-101': typeof PrivatewithFooterCannabis101PageRoute
  '/careplan': typeof PrivatewithFooterCareplanPageRoute
  '/clinical-team': typeof PrivatewithFooterClinicalTeamPageRoute
  '/product-research-and-testing': typeof PrivatewithFooterProductResearchAndTestingPageRoute
  '/progress': typeof PrivatewithFooterProgressPageRoute
  '/auth/oidc/return': typeof GuestAuthOidcReturnPageRoute
  '/faqs/$id': typeof PrivatefaqsFaqsIdPageRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_guest': typeof GuestLayoutRouteWithChildren
  '/_private': typeof PrivateLayoutRouteWithChildren
  '/_guest/post-purchase': typeof GuestPostPurchaseLayoutRouteWithChildren
  '/_private/(faqs)': typeof PrivatefaqsLayoutRouteWithChildren
  '/_private/(with-footer)': typeof PrivatewithFooterLayoutRouteWithChildren
  '/_guest/profiling': typeof GuestProfilingRouteWithChildren
  '/_guest/profiling/_custom-questions': typeof GuestProfilingCustomQuestionsLayoutRouteWithChildren
  '/_guest/forgot-password/': typeof GuestForgotPasswordPageRoute
  '/_guest/login/': typeof GuestLoginPageRoute
  '/_guest/password-expired/': typeof GuestPasswordExpiredPageRoute
  '/_guest/password-updated/': typeof GuestPasswordUpdatedPageRoute
  '/_guest/personify-get-started/': typeof GuestPersonifyGetStartedPageRoute
  '/_guest/post-purchase/': typeof GuestPostPurchasePageRoute
  '/_guest/profiling/': typeof GuestProfilingPageRoute
  '/_guest/reset-password/': typeof GuestResetPasswordPageRoute
  '/_private/(with-footer)/': typeof PrivatewithFooterPageRoute
  '/_private/messages/': typeof PrivateMessagesPageRoute
  '/_private/survey/': typeof PrivateSurveyPageRoute
  '/_guest/profiling/_custom-questions/email-check': typeof GuestProfilingCustomQuestionsEmailCheckRoute
  '/_guest/profiling/_custom-questions/hp-feedback': typeof GuestProfilingCustomQuestionsHpFeedbackRoute
  '/_guest/profiling/_custom-questions/otp': typeof GuestProfilingCustomQuestionsOtpRoute
  '/_guest/post-purchase/recommendations/': typeof GuestPostPurchaseRecommendationsPageRoute
  '/_guest/post-purchase/subscribe/': typeof GuestPostPurchaseSubscribePageRoute
  '/_guest/post-purchase/survey/': typeof GuestPostPurchaseSurveyPageRoute
  '/_guest/profiling/password/': typeof GuestProfilingPasswordPageRoute
  '/_private/(faqs)/faqs/': typeof PrivatefaqsFaqsPageRoute
  '/_private/(faqs)/more/': typeof PrivatefaqsMorePageRoute
  '/_private/(with-footer)/$/': typeof PrivatewithFooterSplatPageRoute
  '/_private/(with-footer)/cannabis-101/': typeof PrivatewithFooterCannabis101PageRoute
  '/_private/(with-footer)/careplan/': typeof PrivatewithFooterCareplanPageRoute
  '/_private/(with-footer)/clinical-team/': typeof PrivatewithFooterClinicalTeamPageRoute
  '/_private/(with-footer)/product-research-and-testing/': typeof PrivatewithFooterProductResearchAndTestingPageRoute
  '/_private/(with-footer)/progress/': typeof PrivatewithFooterProgressPageRoute
  '/_guest/auth/oidc/return/': typeof GuestAuthOidcReturnPageRoute
  '/_private/(faqs)/faqs/$id/': typeof PrivatefaqsFaqsIdPageRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/post-purchase'
    | '/profiling'
    | '/forgot-password'
    | '/login'
    | '/password-expired'
    | '/password-updated'
    | '/personify-get-started'
    | '/post-purchase/'
    | '/profiling/'
    | '/reset-password'
    | '/'
    | '/messages'
    | '/survey'
    | '/profiling/email-check'
    | '/profiling/hp-feedback'
    | '/profiling/otp'
    | '/post-purchase/recommendations'
    | '/post-purchase/subscribe'
    | '/post-purchase/survey'
    | '/profiling/password'
    | '/faqs'
    | '/more'
    | '/$'
    | '/cannabis-101'
    | '/careplan'
    | '/clinical-team'
    | '/product-research-and-testing'
    | '/progress'
    | '/auth/oidc/return'
    | '/faqs/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/profiling'
    | '/forgot-password'
    | '/login'
    | '/password-expired'
    | '/password-updated'
    | '/personify-get-started'
    | '/post-purchase'
    | '/reset-password'
    | '/'
    | '/messages'
    | '/survey'
    | '/profiling/email-check'
    | '/profiling/hp-feedback'
    | '/profiling/otp'
    | '/post-purchase/recommendations'
    | '/post-purchase/subscribe'
    | '/post-purchase/survey'
    | '/profiling/password'
    | '/faqs'
    | '/more'
    | '/$'
    | '/cannabis-101'
    | '/careplan'
    | '/clinical-team'
    | '/product-research-and-testing'
    | '/progress'
    | '/auth/oidc/return'
    | '/faqs/$id'
  id:
    | '__root__'
    | '/_guest'
    | '/_private'
    | '/_guest/post-purchase'
    | '/_private/(faqs)'
    | '/_private/(with-footer)'
    | '/_guest/profiling'
    | '/_guest/profiling/_custom-questions'
    | '/_guest/forgot-password/'
    | '/_guest/login/'
    | '/_guest/password-expired/'
    | '/_guest/password-updated/'
    | '/_guest/personify-get-started/'
    | '/_guest/post-purchase/'
    | '/_guest/profiling/'
    | '/_guest/reset-password/'
    | '/_private/(with-footer)/'
    | '/_private/messages/'
    | '/_private/survey/'
    | '/_guest/profiling/_custom-questions/email-check'
    | '/_guest/profiling/_custom-questions/hp-feedback'
    | '/_guest/profiling/_custom-questions/otp'
    | '/_guest/post-purchase/recommendations/'
    | '/_guest/post-purchase/subscribe/'
    | '/_guest/post-purchase/survey/'
    | '/_guest/profiling/password/'
    | '/_private/(faqs)/faqs/'
    | '/_private/(faqs)/more/'
    | '/_private/(with-footer)/$/'
    | '/_private/(with-footer)/cannabis-101/'
    | '/_private/(with-footer)/careplan/'
    | '/_private/(with-footer)/clinical-team/'
    | '/_private/(with-footer)/product-research-and-testing/'
    | '/_private/(with-footer)/progress/'
    | '/_guest/auth/oidc/return/'
    | '/_private/(faqs)/faqs/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  GuestLayoutRoute: typeof GuestLayoutRouteWithChildren
  PrivateLayoutRoute: typeof PrivateLayoutRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_private': {
      id: '/_private'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PrivateLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_guest': {
      id: '/_guest'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof GuestLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_guest/profiling': {
      id: '/_guest/profiling'
      path: '/profiling'
      fullPath: '/profiling'
      preLoaderRoute: typeof GuestProfilingRouteImport
      parentRoute: typeof GuestLayoutRoute
    }
    '/_private/(with-footer)': {
      id: '/_private/(with-footer)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PrivatewithFooterLayoutRouteImport
      parentRoute: typeof PrivateLayoutRoute
    }
    '/_private/(faqs)': {
      id: '/_private/(faqs)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PrivatefaqsLayoutRouteImport
      parentRoute: typeof PrivateLayoutRoute
    }
    '/_guest/post-purchase': {
      id: '/_guest/post-purchase'
      path: '/post-purchase'
      fullPath: '/post-purchase'
      preLoaderRoute: typeof GuestPostPurchaseLayoutRouteImport
      parentRoute: typeof GuestLayoutRoute
    }
    '/_private/survey/': {
      id: '/_private/survey/'
      path: '/survey'
      fullPath: '/survey'
      preLoaderRoute: typeof PrivateSurveyPageRouteImport
      parentRoute: typeof PrivateLayoutRoute
    }
    '/_private/messages/': {
      id: '/_private/messages/'
      path: '/messages'
      fullPath: '/messages'
      preLoaderRoute: typeof PrivateMessagesPageRouteImport
      parentRoute: typeof PrivateLayoutRoute
    }
    '/_private/(with-footer)/': {
      id: '/_private/(with-footer)/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof PrivatewithFooterPageRouteImport
      parentRoute: typeof PrivatewithFooterLayoutRoute
    }
    '/_guest/reset-password/': {
      id: '/_guest/reset-password/'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof GuestResetPasswordPageRouteImport
      parentRoute: typeof GuestLayoutRoute
    }
    '/_guest/profiling/': {
      id: '/_guest/profiling/'
      path: '/'
      fullPath: '/profiling/'
      preLoaderRoute: typeof GuestProfilingPageRouteImport
      parentRoute: typeof GuestProfilingRoute
    }
    '/_guest/post-purchase/': {
      id: '/_guest/post-purchase/'
      path: '/'
      fullPath: '/post-purchase/'
      preLoaderRoute: typeof GuestPostPurchasePageRouteImport
      parentRoute: typeof GuestPostPurchaseLayoutRoute
    }
    '/_guest/personify-get-started/': {
      id: '/_guest/personify-get-started/'
      path: '/personify-get-started'
      fullPath: '/personify-get-started'
      preLoaderRoute: typeof GuestPersonifyGetStartedPageRouteImport
      parentRoute: typeof GuestLayoutRoute
    }
    '/_guest/password-updated/': {
      id: '/_guest/password-updated/'
      path: '/password-updated'
      fullPath: '/password-updated'
      preLoaderRoute: typeof GuestPasswordUpdatedPageRouteImport
      parentRoute: typeof GuestLayoutRoute
    }
    '/_guest/password-expired/': {
      id: '/_guest/password-expired/'
      path: '/password-expired'
      fullPath: '/password-expired'
      preLoaderRoute: typeof GuestPasswordExpiredPageRouteImport
      parentRoute: typeof GuestLayoutRoute
    }
    '/_guest/login/': {
      id: '/_guest/login/'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof GuestLoginPageRouteImport
      parentRoute: typeof GuestLayoutRoute
    }
    '/_guest/forgot-password/': {
      id: '/_guest/forgot-password/'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof GuestForgotPasswordPageRouteImport
      parentRoute: typeof GuestLayoutRoute
    }
    '/_guest/profiling/_custom-questions': {
      id: '/_guest/profiling/_custom-questions'
      path: '/profiling'
      fullPath: '/profiling'
      preLoaderRoute: typeof GuestProfilingCustomQuestionsLayoutRouteImport
      parentRoute: typeof GuestProfilingRoute
    }
    '/_private/(with-footer)/progress/': {
      id: '/_private/(with-footer)/progress/'
      path: '/progress'
      fullPath: '/progress'
      preLoaderRoute: typeof PrivatewithFooterProgressPageRouteImport
      parentRoute: typeof PrivatewithFooterLayoutRoute
    }
    '/_private/(with-footer)/product-research-and-testing/': {
      id: '/_private/(with-footer)/product-research-and-testing/'
      path: '/product-research-and-testing'
      fullPath: '/product-research-and-testing'
      preLoaderRoute: typeof PrivatewithFooterProductResearchAndTestingPageRouteImport
      parentRoute: typeof PrivatewithFooterLayoutRoute
    }
    '/_private/(with-footer)/clinical-team/': {
      id: '/_private/(with-footer)/clinical-team/'
      path: '/clinical-team'
      fullPath: '/clinical-team'
      preLoaderRoute: typeof PrivatewithFooterClinicalTeamPageRouteImport
      parentRoute: typeof PrivatewithFooterLayoutRoute
    }
    '/_private/(with-footer)/careplan/': {
      id: '/_private/(with-footer)/careplan/'
      path: '/careplan'
      fullPath: '/careplan'
      preLoaderRoute: typeof PrivatewithFooterCareplanPageRouteImport
      parentRoute: typeof PrivatewithFooterLayoutRoute
    }
    '/_private/(with-footer)/cannabis-101/': {
      id: '/_private/(with-footer)/cannabis-101/'
      path: '/cannabis-101'
      fullPath: '/cannabis-101'
      preLoaderRoute: typeof PrivatewithFooterCannabis101PageRouteImport
      parentRoute: typeof PrivatewithFooterLayoutRoute
    }
    '/_private/(with-footer)/$/': {
      id: '/_private/(with-footer)/$/'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof PrivatewithFooterSplatPageRouteImport
      parentRoute: typeof PrivatewithFooterLayoutRoute
    }
    '/_private/(faqs)/more/': {
      id: '/_private/(faqs)/more/'
      path: '/more'
      fullPath: '/more'
      preLoaderRoute: typeof PrivatefaqsMorePageRouteImport
      parentRoute: typeof PrivatefaqsLayoutRoute
    }
    '/_private/(faqs)/faqs/': {
      id: '/_private/(faqs)/faqs/'
      path: '/faqs'
      fullPath: '/faqs'
      preLoaderRoute: typeof PrivatefaqsFaqsPageRouteImport
      parentRoute: typeof PrivatefaqsLayoutRoute
    }
    '/_guest/profiling/password/': {
      id: '/_guest/profiling/password/'
      path: '/password'
      fullPath: '/profiling/password'
      preLoaderRoute: typeof GuestProfilingPasswordPageRouteImport
      parentRoute: typeof GuestProfilingRoute
    }
    '/_guest/post-purchase/survey/': {
      id: '/_guest/post-purchase/survey/'
      path: '/survey'
      fullPath: '/post-purchase/survey'
      preLoaderRoute: typeof GuestPostPurchaseSurveyPageRouteImport
      parentRoute: typeof GuestPostPurchaseLayoutRoute
    }
    '/_guest/post-purchase/subscribe/': {
      id: '/_guest/post-purchase/subscribe/'
      path: '/subscribe'
      fullPath: '/post-purchase/subscribe'
      preLoaderRoute: typeof GuestPostPurchaseSubscribePageRouteImport
      parentRoute: typeof GuestPostPurchaseLayoutRoute
    }
    '/_guest/post-purchase/recommendations/': {
      id: '/_guest/post-purchase/recommendations/'
      path: '/recommendations'
      fullPath: '/post-purchase/recommendations'
      preLoaderRoute: typeof GuestPostPurchaseRecommendationsPageRouteImport
      parentRoute: typeof GuestPostPurchaseLayoutRoute
    }
    '/_guest/profiling/_custom-questions/otp': {
      id: '/_guest/profiling/_custom-questions/otp'
      path: '/otp'
      fullPath: '/profiling/otp'
      preLoaderRoute: typeof GuestProfilingCustomQuestionsOtpRouteImport
      parentRoute: typeof GuestProfilingCustomQuestionsLayoutRoute
    }
    '/_guest/profiling/_custom-questions/hp-feedback': {
      id: '/_guest/profiling/_custom-questions/hp-feedback'
      path: '/hp-feedback'
      fullPath: '/profiling/hp-feedback'
      preLoaderRoute: typeof GuestProfilingCustomQuestionsHpFeedbackRouteImport
      parentRoute: typeof GuestProfilingCustomQuestionsLayoutRoute
    }
    '/_guest/profiling/_custom-questions/email-check': {
      id: '/_guest/profiling/_custom-questions/email-check'
      path: '/email-check'
      fullPath: '/profiling/email-check'
      preLoaderRoute: typeof GuestProfilingCustomQuestionsEmailCheckRouteImport
      parentRoute: typeof GuestProfilingCustomQuestionsLayoutRoute
    }
    '/_private/(faqs)/faqs/$id/': {
      id: '/_private/(faqs)/faqs/$id/'
      path: '/faqs/$id'
      fullPath: '/faqs/$id'
      preLoaderRoute: typeof PrivatefaqsFaqsIdPageRouteImport
      parentRoute: typeof PrivatefaqsLayoutRoute
    }
    '/_guest/auth/oidc/return/': {
      id: '/_guest/auth/oidc/return/'
      path: '/auth/oidc/return'
      fullPath: '/auth/oidc/return'
      preLoaderRoute: typeof GuestAuthOidcReturnPageRouteImport
      parentRoute: typeof GuestLayoutRoute
    }
  }
}

interface GuestPostPurchaseLayoutRouteChildren {
  GuestPostPurchasePageRoute: typeof GuestPostPurchasePageRoute
  GuestPostPurchaseRecommendationsPageRoute: typeof GuestPostPurchaseRecommendationsPageRoute
  GuestPostPurchaseSubscribePageRoute: typeof GuestPostPurchaseSubscribePageRoute
  GuestPostPurchaseSurveyPageRoute: typeof GuestPostPurchaseSurveyPageRoute
}

const GuestPostPurchaseLayoutRouteChildren: GuestPostPurchaseLayoutRouteChildren =
  {
    GuestPostPurchasePageRoute: GuestPostPurchasePageRoute,
    GuestPostPurchaseRecommendationsPageRoute:
      GuestPostPurchaseRecommendationsPageRoute,
    GuestPostPurchaseSubscribePageRoute: GuestPostPurchaseSubscribePageRoute,
    GuestPostPurchaseSurveyPageRoute: GuestPostPurchaseSurveyPageRoute,
  }

const GuestPostPurchaseLayoutRouteWithChildren =
  GuestPostPurchaseLayoutRoute._addFileChildren(
    GuestPostPurchaseLayoutRouteChildren,
  )

interface GuestProfilingCustomQuestionsLayoutRouteChildren {
  GuestProfilingCustomQuestionsEmailCheckRoute: typeof GuestProfilingCustomQuestionsEmailCheckRoute
  GuestProfilingCustomQuestionsHpFeedbackRoute: typeof GuestProfilingCustomQuestionsHpFeedbackRoute
  GuestProfilingCustomQuestionsOtpRoute: typeof GuestProfilingCustomQuestionsOtpRoute
}

const GuestProfilingCustomQuestionsLayoutRouteChildren: GuestProfilingCustomQuestionsLayoutRouteChildren =
  {
    GuestProfilingCustomQuestionsEmailCheckRoute:
      GuestProfilingCustomQuestionsEmailCheckRoute,
    GuestProfilingCustomQuestionsHpFeedbackRoute:
      GuestProfilingCustomQuestionsHpFeedbackRoute,
    GuestProfilingCustomQuestionsOtpRoute:
      GuestProfilingCustomQuestionsOtpRoute,
  }

const GuestProfilingCustomQuestionsLayoutRouteWithChildren =
  GuestProfilingCustomQuestionsLayoutRoute._addFileChildren(
    GuestProfilingCustomQuestionsLayoutRouteChildren,
  )

interface GuestProfilingRouteChildren {
  GuestProfilingCustomQuestionsLayoutRoute: typeof GuestProfilingCustomQuestionsLayoutRouteWithChildren
  GuestProfilingPageRoute: typeof GuestProfilingPageRoute
  GuestProfilingPasswordPageRoute: typeof GuestProfilingPasswordPageRoute
}

const GuestProfilingRouteChildren: GuestProfilingRouteChildren = {
  GuestProfilingCustomQuestionsLayoutRoute:
    GuestProfilingCustomQuestionsLayoutRouteWithChildren,
  GuestProfilingPageRoute: GuestProfilingPageRoute,
  GuestProfilingPasswordPageRoute: GuestProfilingPasswordPageRoute,
}

const GuestProfilingRouteWithChildren = GuestProfilingRoute._addFileChildren(
  GuestProfilingRouteChildren,
)

interface GuestLayoutRouteChildren {
  GuestPostPurchaseLayoutRoute: typeof GuestPostPurchaseLayoutRouteWithChildren
  GuestProfilingRoute: typeof GuestProfilingRouteWithChildren
  GuestForgotPasswordPageRoute: typeof GuestForgotPasswordPageRoute
  GuestLoginPageRoute: typeof GuestLoginPageRoute
  GuestPasswordExpiredPageRoute: typeof GuestPasswordExpiredPageRoute
  GuestPasswordUpdatedPageRoute: typeof GuestPasswordUpdatedPageRoute
  GuestPersonifyGetStartedPageRoute: typeof GuestPersonifyGetStartedPageRoute
  GuestResetPasswordPageRoute: typeof GuestResetPasswordPageRoute
  GuestAuthOidcReturnPageRoute: typeof GuestAuthOidcReturnPageRoute
}

const GuestLayoutRouteChildren: GuestLayoutRouteChildren = {
  GuestPostPurchaseLayoutRoute: GuestPostPurchaseLayoutRouteWithChildren,
  GuestProfilingRoute: GuestProfilingRouteWithChildren,
  GuestForgotPasswordPageRoute: GuestForgotPasswordPageRoute,
  GuestLoginPageRoute: GuestLoginPageRoute,
  GuestPasswordExpiredPageRoute: GuestPasswordExpiredPageRoute,
  GuestPasswordUpdatedPageRoute: GuestPasswordUpdatedPageRoute,
  GuestPersonifyGetStartedPageRoute: GuestPersonifyGetStartedPageRoute,
  GuestResetPasswordPageRoute: GuestResetPasswordPageRoute,
  GuestAuthOidcReturnPageRoute: GuestAuthOidcReturnPageRoute,
}

const GuestLayoutRouteWithChildren = GuestLayoutRoute._addFileChildren(
  GuestLayoutRouteChildren,
)

interface PrivatefaqsLayoutRouteChildren {
  PrivatefaqsFaqsPageRoute: typeof PrivatefaqsFaqsPageRoute
  PrivatefaqsMorePageRoute: typeof PrivatefaqsMorePageRoute
  PrivatefaqsFaqsIdPageRoute: typeof PrivatefaqsFaqsIdPageRoute
}

const PrivatefaqsLayoutRouteChildren: PrivatefaqsLayoutRouteChildren = {
  PrivatefaqsFaqsPageRoute: PrivatefaqsFaqsPageRoute,
  PrivatefaqsMorePageRoute: PrivatefaqsMorePageRoute,
  PrivatefaqsFaqsIdPageRoute: PrivatefaqsFaqsIdPageRoute,
}

const PrivatefaqsLayoutRouteWithChildren =
  PrivatefaqsLayoutRoute._addFileChildren(PrivatefaqsLayoutRouteChildren)

interface PrivatewithFooterLayoutRouteChildren {
  PrivatewithFooterPageRoute: typeof PrivatewithFooterPageRoute
  PrivatewithFooterSplatPageRoute: typeof PrivatewithFooterSplatPageRoute
  PrivatewithFooterCannabis101PageRoute: typeof PrivatewithFooterCannabis101PageRoute
  PrivatewithFooterCareplanPageRoute: typeof PrivatewithFooterCareplanPageRoute
  PrivatewithFooterClinicalTeamPageRoute: typeof PrivatewithFooterClinicalTeamPageRoute
  PrivatewithFooterProductResearchAndTestingPageRoute: typeof PrivatewithFooterProductResearchAndTestingPageRoute
  PrivatewithFooterProgressPageRoute: typeof PrivatewithFooterProgressPageRoute
}

const PrivatewithFooterLayoutRouteChildren: PrivatewithFooterLayoutRouteChildren =
  {
    PrivatewithFooterPageRoute: PrivatewithFooterPageRoute,
    PrivatewithFooterSplatPageRoute: PrivatewithFooterSplatPageRoute,
    PrivatewithFooterCannabis101PageRoute:
      PrivatewithFooterCannabis101PageRoute,
    PrivatewithFooterCareplanPageRoute: PrivatewithFooterCareplanPageRoute,
    PrivatewithFooterClinicalTeamPageRoute:
      PrivatewithFooterClinicalTeamPageRoute,
    PrivatewithFooterProductResearchAndTestingPageRoute:
      PrivatewithFooterProductResearchAndTestingPageRoute,
    PrivatewithFooterProgressPageRoute: PrivatewithFooterProgressPageRoute,
  }

const PrivatewithFooterLayoutRouteWithChildren =
  PrivatewithFooterLayoutRoute._addFileChildren(
    PrivatewithFooterLayoutRouteChildren,
  )

interface PrivateLayoutRouteChildren {
  PrivatefaqsLayoutRoute: typeof PrivatefaqsLayoutRouteWithChildren
  PrivatewithFooterLayoutRoute: typeof PrivatewithFooterLayoutRouteWithChildren
  PrivateMessagesPageRoute: typeof PrivateMessagesPageRoute
  PrivateSurveyPageRoute: typeof PrivateSurveyPageRoute
}

const PrivateLayoutRouteChildren: PrivateLayoutRouteChildren = {
  PrivatefaqsLayoutRoute: PrivatefaqsLayoutRouteWithChildren,
  PrivatewithFooterLayoutRoute: PrivatewithFooterLayoutRouteWithChildren,
  PrivateMessagesPageRoute: PrivateMessagesPageRoute,
  PrivateSurveyPageRoute: PrivateSurveyPageRoute,
}

const PrivateLayoutRouteWithChildren = PrivateLayoutRoute._addFileChildren(
  PrivateLayoutRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  GuestLayoutRoute: GuestLayoutRouteWithChildren,
  PrivateLayoutRoute: PrivateLayoutRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
